import React, { useState } from "react";
import Lottie from "react-lottie";
import StartTourAnimation from "../assets/start-tour.json";
import WatchVideoAnimation from "../assets/watch-video.json";

const TourModal = ({ isOpen, onClose, onStartTour }) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  // Lottie animation options
  const startTourOptions = {
    loop: true,
    autoplay: true,
    animationData: StartTourAnimation,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
  };

  const watchVideoOptions = {
    loop: true,
    autoplay: true,
    animationData: WatchVideoAnimation,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
  };

  return (
    <>
      {/* 📌 Main Tour Modal */}
      {isOpen && !isVideoOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9999]">
          <div className="bg-white p-4 w-72 rounded-lg shadow-lg text-center relative flex flex-col items-center">
            <h2 className="text-sm font-semibold mb-3">Choose an Option</h2>

            {/* 🎬 Start Tour Animation */}
            <div className="w-32 h-32 cursor-pointer" onClick={onStartTour}>
              <Lottie options={startTourOptions} height={100} width={100} />
            </div>
            <p className="text-xs mb-2">Start Tour</p>

            {/* 🎥 Watch Video Animation */}
            <div className="w-32 h-32 cursor-pointer" onClick={() => setIsVideoOpen(true)}>
              <Lottie options={watchVideoOptions} height={100} width={100} />
            </div>
            <p className="text-xs">Watch Video</p>

            {/* ❌ Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-lg"
              onClick={onClose}
            >
              ✖
            </button>
          </div>
        </div>
      )}

      {/* 🎥 Video Player Modal */}
      {isVideoOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[9999]">
          <div className="bg-white p-4 w-[90%] max-w-md rounded-lg shadow-lg text-center relative">
            <h2 className="text-sm font-semibold mb-3">Watch Video</h2>

            {/* Embedded Video */}
            <video width="100%" controls autoPlay>
              <source src="/comp-guide.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* ❌ Close Video Button */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-lg"
              onClick={() => setIsVideoOpen(false)}
            >
              ✖
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TourModal;
